import React from 'react';
import {motion} from "framer-motion";
import { Link } from 'react-router-dom';

import { zoomIn } from '../../../utils/zoomIn';
import Title from '../../common/title';

import ServiceIconSeven from '../../../assets/icons/serviceIconSeven';
import ServiceIconEight from '../../../assets/icons/serviceIconEight';
import ServiceIconNine from '../../../assets/icons/serviceIconNine';
import ServiceIconTen from '../../../assets/icons/serviceIconTen';
import ServiceIconEleven from '../../../assets/icons/serviceIconEleven';
import ServiceIconTwelfth from '../../../assets/icons/serviceIconTwelfth';


export const servicesDataOne = [
  {
    id: 1,
    service_name: "商業合約範本",
    service_details: "我們提供多種由專業律師打造的合約範本，讓您可以免費開始享受 DraftLegal 的法律服務",
    link: "./contract",
    linkDesc: "免費合約由此下載",
    src: ServiceIconSeven
  },
  {
    id: 2,
    service_name: "AI 合約生成",
    service_details: "覺得常用的制式合約條文還要聯絡律師修改太過麻煩？那就交給 DraftLegal 的專業法律 AI！",
    link: "/service-details",
    linkDesc: "點此開始生成合約",
    src: ServiceIconEight
  },
  {
    id: 3,
    service_name: "真人律師合約審閱",
    service_details: "較為複雜的商業情境，或者有想確認的事項，就聯絡我們專業的法律團隊吧！",
    link: "/contact",
    linkDesc: "聯絡專業律師團隊",
    src: ServiceIconNine
  },
  /*
  {
    id: 4,
    service_name: "Security Training and Awareness",
    service_details: "This service focuses on securing end-user devices like laptops, desktops, and mobile devices from cybersecurity threats.",
    link: "/service-details",
    src: ServiceIconTen
  },
  {
    id: 5,
    service_name: "Security Awareness Training",
    service_details: "This service focuses on securing end-user devices like laptops, desktops, and mobile devices from cybersecurity threats.",
    link: "/service-details",
    src: ServiceIconEleven
  },
  {
    id: 6,
    service_name: "Application Security Testing",
    service_details: "This service focuses on securing end-user devices like laptops, desktops, and mobile devices from cybersecurity threats.",
    link: "/service-details",
    src: ServiceIconTwelfth
  },
  */

];



const ServicesOne = () => {
  return (
    <div 
      className="services-area style-2 pb-75" 
      style={{ paddingTop: '50px', backgroundColor: '#f5f5f5' }}
    >
      <div className="container">
        <Title 
          sectionName={"服務項目"} 
          sectionTitle={"從合約的第一個字到完稿，由律師打造出的 AI 為您操刀"} 
          sectionNameColor="#1e5651"
          sectionTitleColor="#272b3a"
          sectionNameFontSize="25px"
          sectionTitleFontSize="18px"
          style={"style-2"}
        />
        <div className="row" >
          {
            servicesDataOne.map(({ id, link, linkDesc, service_details, service_name, src }) => {
              return (
                <motion.div key={id} className="col-lg-4 col-sm-6"
                  initial="offscreen"
                  whileInView="onscreen"
                  variants={zoomIn(id)}
                  viewport={{ once: true, amount: 0.4 }}
                >
                  <div className="single-services-info" style={{ minHeight:'320px' }}>
                    <div className="icon">
                      {src()}
                    </div>
                    <h3>
                      <Link className="text-decoration-none" to={link}>{service_name}</Link>
                    </h3>
                    <p>{service_details}</p>

                    <Link
                      className="read-more text-decoration-none"
                      to={link}
                      style={{ 
                        opacity: '0.9',
                        fontSize: '13.5px'
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = 'white')}
                      onMouseLeave={(e) => (e.currentTarget.style.color = '#c0bfbf')}
                    >
                      {linkDesc || "Read More"}
                      <i className="ri-arrow-right-line"></i>
                    </Link>

                  </div>
                </motion.div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default ServicesOne;



